import { z } from "zod/v4-mini";

import { TandemEventDefinition } from "@/lib/drivers/tandem/TandemTypes";
import { cz } from "@/utils/zodUtils";

export type CartridgeFilledPayload = {
  insulin_display?: number;
  insulin_actual?: number;
};

export type CartridgeFilledEvent = {
  insulinDisplay?: number;
  insulinActual?: number;
};

const cartridgeFilledSchema = z.object({
  insulin_display: cz.permissive(z.number()),
  insulin_actual: cz.permissive(z.number()),
});

export const LID_CARTRIDGE_FILLED = {
  value: 0x21,
  name: "Cartridge Filled Event",
  format: "if........",
  fields: ["insulin_display", "insulin_actual"],
  postprocess: rec => ({
    insulinDisplay: rec.insulin_display,
    insulinActual: rec.insulin_actual,
  }),
  schema: cartridgeFilledSchema,
} as const satisfies TandemEventDefinition<CartridgeFilledPayload, CartridgeFilledEvent>;
